/*!
    * @product/scmp-sdk 1.0.215
    * 4ea66bed59ebf69ab054abb30a7e3308ecad0a86
  */
function i(...d){var n,a;typeof window>"u"||!((n=window)!==null&&n!==void 0&&(a=n.dataLayer)!==null&&a!==void 0&&a.push)||window.dataLayer.push(arguments)}export{i as a};
//# sourceMappingURL=chunk-BUFZE4IT.js.map
